import rabbitSvg from '@/assets/svg/rabbit.svg';
import umbrellaSvg from '@/assets/svg/umbrella.svg';
import umbrellaBodySvg from '@/assets/svg/umbrella-body.svg';
import type { PrecipitationType } from '@/types/weather';
import { RABBIT_BODY_PATH, RABBIT_BODY_VIEWBOX } from './rabbitBodyPath';
import { tint } from '../tint';

interface Props {
  precipitation: PrecipitationType;
  skyColor: string;
}

const RAINY: PrecipitationType[] = ['drizzle', 'rain', 'heavy-rain', 'sleet'];

export function RabbitLayer({ precipitation, skyColor }: Props) {
  const raining = RAINY.includes(precipitation);
  const bodyColor = tint(skyColor, 0.55);
  return (
    <div className="layer" style={{ zIndex: 80, pointerEvents: 'none' }}>
      <svg
        viewBox={RABBIT_BODY_VIEWBOX}
        aria-hidden="true"
        style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          height: '40vh',
          width: 'auto',
          display: 'block',
        }}
      >
        <path
          d={RABBIT_BODY_PATH}
          fill={bodyColor}
          style={{ transition: 'fill 4s ease-in-out' }}
        />
      </svg>
      <img
        src={rabbitSvg}
        alt=""
        aria-hidden="true"
        style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          height: '40vh',
          width: 'auto',
        }}
      />
      {raining && (
        <>
          <img
            src={umbrellaBodySvg}
            alt=""
            aria-hidden="true"
            style={{
              position: 'absolute',
              bottom: '8vh',
              left: '46%',
              transform: 'translateX(-50%)',
              height: '56vh',
              width: 'auto',
            }}
          />
          <img
            src={umbrellaSvg}
            alt=""
            aria-hidden="true"
            style={{
              position: 'absolute',
              bottom: '8vh',
              left: '46%',
              transform: 'translateX(-50%)',
              height: '56vh',
              width: 'auto',
            }}
          />
        </>
      )}
    </div>
  );
}
